import protoRoot from "../proto-root";

const name = "stopLullabyAfterMonitoringRpcRequest";

function create({ monitoringId }) {
  const StopLullabyAfterMonitoringRpcRequest = protoRoot.lookupType(
    "comm.StopLullabyAfterMonitoringRpcRequest"
  );

  const request = StopLullabyAfterMonitoringRpcRequest.create({ monitoringId });
  return { payload: request, name };
}

export default {
  create,
  name
};

// message StopLullabyAfterMonitoringRpcRequest {
//   string monitoringId = 1;
// }
